export enum AsyncDataPreset {
  Categories = 'categories',
  Users = 'users',
}
